
import { defineComponent } from "vue";

export default defineComponent({
  name: "TransparentButton",
  props: {
    title: {
      type: String,
      required: true
    }
  }
});
